import { createFileRoute } from "@tanstack/react-router";
import { DomainsPanel } from "@/features/domains/DomainsPanel";
import { DrumlinAddressPanel } from "@/features/domains/DrumlinAddressPanel";

export const Route = createFileRoute(
  "/_app/o/$orgId/projects/$projectId/services/$serviceId/domains",
)({
  component: DomainsScreen,
});

function DomainsScreen() {
  const { orgId, projectId, serviceId } = Route.useParams();
  // The free address first, then the ones you brought. That is the order they
  // arrive in, and the order somebody reads them in when working out which of
  // them their application is actually answering on.
  return (
    <div className="flex flex-col gap-6">
      <DrumlinAddressPanel orgId={orgId} projectId={projectId} serviceId={serviceId} />
      <DomainsPanel orgId={orgId} projectId={projectId} serviceId={serviceId} />
    </div>
  );
}
